import type { ReadingStatus } from './schedule';

export type Tone = 'ok' | 'warn' | 'bad' | 'muted';

export interface StatusUi {
  tone: Tone;
  label: string;      // short chip label
  headline: string;   // hero headline
  canLog: boolean;
}

export function statusUi(s: ReadingStatus): StatusUi {
  switch (s) {
    case 'NO_HISTORY':
      return { tone: 'ok', label: 'Ready', headline: 'Ready to log', canLog: true };
    case 'EARLY_OK':
      return { tone: 'ok', label: 'Ready', headline: 'Ready to log (early)', canLog: true };
    case 'DUE':
      return { tone: 'warn', label: 'Due now', headline: 'Reading is due', canLog: true };
    case 'OVERDUE':
      return { tone: 'bad', label: 'Overdue', headline: 'Reading is overdue', canLog: true };
    case 'BLOCKED':
      return { tone: 'muted', label: 'Locked', headline: 'Not available yet', canLog: false };
  }
}

/** "2h 05m ago" style. */
export function ago(iso: string | null | undefined): string {
  if (!iso) return 'never';
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return '—';
  if (ms < 60_000) return 'just now';
  const m = Math.floor(ms / 60_000);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h < 24) return rem ? `${h}h ${rem}m ago` : `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
